// ═══════════════════════════════════════════════════════════════════════════
// LegalPage — layout partagé des pages légales (Privacy / Terms), dans la
// même direction visuelle que la landing (navy + glass + accents sky).
// Bilingue : le contenu arrive déjà résolu dans la bonne langue.
//
// `content` : { eyebrow, title, updated, sections: [{ h, p?[], list?[] }] }
// Les items de `p` et `list` acceptent du JSX (liens, <strong>…).
// ═══════════════════════════════════════════════════════════════════════════

import logoNameDispo from "../assets/logo-name-dispo.png";
import "../styles/landing.css";

const LegalPage = ({ content, lang = "fr" }) => {
  const homePath = lang === "en" ? "/en" : "/";
  const goHome = () => {
    window.history.pushState(null, "", homePath);
    window.location.reload();
  };

  return (
    <div className="lgl">
      <nav className="lgl-nav">
        <img src={logoNameDispo} alt="Dispo" onClick={goHome} />
        <button onClick={goHome} className="lgl-back">
          ← {lang === "en" ? "Back to home" : "Retour à l'accueil"}
        </button>
      </nav>

      <main className="lgl-card">
        <p className="lgl-eyebrow">{content.eyebrow}</p>
        <h1>{content.title}</h1>
        <p className="lgl-updated">{content.updated}</p>

        {content.sections.map((s, i) => (
          <section key={i}>
            <h2>
              <span>{String(i + 1).padStart(2, "0")}</span>
              {s.h}
            </h2>
            {(s.p || []).map((para, j) => (
              <p key={j}>{para}</p>
            ))}
            {s.list && (
              <ul>
                {s.list.map((item, j) => (
                  <li key={j}>{item}</li>
                ))}
              </ul>
            )}
            {(s.after || []).map((para, j) => (
              <p key={`a${j}`}>{para}</p>
            ))}
          </section>
        ))}
      </main>
    </div>
  );
};

export default LegalPage;
